import { render, staticRenderFns } from "./OrderStateShow.vue?vue&type=template&id=7d5128f7&"
import script from "./OrderStateShow.vue?vue&type=script&lang=js&"
export * from "./OrderStateShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports